if (document.getElementById('js-zip')) {
  document.getElementById('js-zip').addEventListener(
    'keyup',
    function () {
      // 各入出力先をnameから指定
      // 郵便番号上3桁もしくは7桁, 郵便番号下4桁（不要なら空欄）, 都道府県の出力先, 市区町村～町域の出力先
      AjaxZip3.zip2addr(this, '', 'address', 'address')
    },
    false
  )
}
